import React from 'react';
import { Flame } from 'lucide-react';

const spices = [
  {
    id: 1,
    name: 'Cardamom',
    image: 'https://images.unsplash.com/photo-1599909631715-e3d3c0f4b093?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    uses: 'Essential in Indian desserts and tea'
  },
  {
    id: 2,
    name: 'Cumin Seeds',
    image: 'https://images.unsplash.com/photo-1599909633005-207a1dcf8b9c?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    uses: 'Base spice for curries and rice dishes'
  },
  {
    id: 3,
    name: 'Coriander',
    image: 'https://images.unsplash.com/photo-1599909634479-7469915ac2bc?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    uses: 'Adds fresh flavor to any Indian dish'
  }
];

export default function PopularSpices() {
  return (
    <section className="py-12">
      <div className="container mx-auto px-4">
        <div className="flex items-center gap-2 mb-8">
          <Flame className="text-[#568203]" size={24} />
          <h2 className="text-3xl font-bold text-gray-800">Popular Spices</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {spices.map((spice) => (
            <div key={spice.id} className="bg-white rounded-lg shadow-md overflow-hidden">
              <img src={spice.image} alt={spice.name} className="w-full h-48 object-cover" />
              <div className="p-4">
                <h3 className="text-xl font-semibold mb-2">{spice.name}</h3>
                <p className="text-gray-600">{spice.uses}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}